module.exports = __webpack_public_path__ + "static/media/10000d_g.7c278fcb.jpg";